console.log('Cart.js file loaded successfully');

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      // Remove functionality is now handled by global.js
      console.log('Remove button clicked, but updateQuantity function has been removed');
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      // Only handle changes from quantity inputs that are NOT handled by QuantityInput class
      if (event.target.matches('quantity-input input')) {
        // Skip if this is handled by the QuantityInput class
        return;
      }
      // Handle other quantity inputs that don't use the QuantityInput class
      if (event.target.matches('input[type="number"][name*="updates"]')) {
        this.onChange(event);
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    // Use event delegation by listening on the cart-items element
    this.addEventListener('change', debouncedOnChange.bind(this));

    // Add debounced handler for substitution toggles
    const debouncedToggleHandler = debounce((event) => {
      const toggle = event.target.closest('.switch-container input[type="checkbox"]');
      if (toggle) {
        this.handleSubstitutionToggle(toggle);
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('click', (event) => {
      if (event.target.closest('.switch-container input[type="checkbox"]')) {
        debouncedToggleHandler(event);
      }
    });

    // Add handler for save note button clicks
    this.addEventListener('click', (event) => {
      const saveButton = event.target.closest('.save-note-button');
      if (saveButton) {
        const textarea = saveButton.closest('.note-field').querySelector('textarea[id^="message-"]');
        if (textarea) {
          this.handleNotesChange(textarea);
        }
      }
    });

    // Add handler for cart note changes
    this.addEventListener('change', (event) => {
      console.log('Cart change event triggered:', event.target.id);
      if (event.target.id === 'Cart-note' || event.target.id === 'CartDrawer-Note') {
        console.log('Cart note change detected, calling handleCartNoteChange');
        this.handleCartNoteChange(event.target);
      }
    });

    // Add handler for cart note blur (when field loses focus)
    this.addEventListener('blur', (event) => {
      console.log('Cart blur event triggered:', event.target.id);
      if (event.target.id === 'Cart-note' || event.target.id === 'CartDrawer-Note') {
        console.log('Cart note blur detected, calling handleCartNoteChange');
        this.handleCartNoteChange(event.target);
      }
    }, true);
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // Quantity changes are now handled by global.js
    console.log('Quantity change detected, but updateQuantity function has been removed');
  }

  onCartUpdate() {
    // Skip if we're the source of the update
    if (this.cartUpdateSource === 'cart-items') {
      return;
    }

    // Use the cart data from the event instead of making new requests
    const event = new CustomEvent('cart-update-received', {
      detail: { source: this.tagName }
    });
    document.dispatchEvent(event);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-total',
        section: 'cart-total',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }



  handleCartNoteChange(textarea) {
    console.log('handleCartNoteChange called with textarea:', textarea);
    console.log('Textarea value:', textarea.value);
    
    const note = textarea.value;

    // Clear any existing timeout to debounce the request
    if (this.cartNoteTimeout) {
      console.log('Clearing existing timeout');
      clearTimeout(this.cartNoteTimeout);
    }

    // Debounce the cart note update to prevent too many requests
    this.cartNoteTimeout = setTimeout(() => {
      console.log('Sending cart note update request');
      const body = JSON.stringify({
        note: note
      });
      console.log('Request body:', body);

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          console.log('Cart note update response received:', response.status);
          if (!response.ok) {
            throw new Error('Cart note update failed');
          }
          return response.json();
        })
        .then((cartData) => {
          console.log('Cart note update successful:', cartData);
          // Publish cart update event with the response data
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartData });
        })
        .catch((error) => {
          console.error('Error updating cart note:', error);
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        });
    }, 300); // 300ms debounce delay
    console.log('Timeout set for cart note update');
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getCartNote() {
    // Get cart note from main cart page
    const cartNote = document.getElementById('Cart-note');
    if (cartNote) {
      return cartNote.value;
    }
    
    // Get cart note from cart drawer
    const cartDrawerNote = document.getElementById('CartDrawer-Note');
    if (cartDrawerNote) {
      return cartDrawerNote.value;
    }
    
    return '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  enableLoadingNote(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner-note`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner-note`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  enableLoadingNoteHider(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
  
    // Select the divs you want to hide
    const cartItemElements = document.querySelectorAll(`#prod-notes-${line - 1}`);
    const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} #prod-notes-${line}`);
  
    // Hide the divs by adding the 'hidden' class (or use style.display = 'none')
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      overlay.classList.add('hidden'); // Assuming the 'hidden' class sets display: none
    });
  
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoadingNote(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner-note`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner-note`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  disableLoadingNoteHider(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
  
    // Select the divs you want to hide
    const cartItemElements = document.querySelectorAll(`#prod-notes-${line - 1}`);
    const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} #prod-notes-${line}`);
  
    // Hide the divs by adding the 'hidden' class (or use style.display = 'none')
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      overlay.classList.remove('hidden'); // Assuming the 'hidden' class sets display: none
    });
  
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  }

  handleSubstitutionToggle(toggle) {
    const lineItemKey = toggle.dataset.lineItemKey;
    const isAllowed = toggle.checked;
    
    // Get the current quantity from the quantity input using the correct selector
    const cartItem = toggle.closest('.cart-item');
    const quantityInput = cartItem ? cartItem.querySelector('.quantity__input') : null;
    const currentQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
    
    // Get the current notes value
    const notesTextarea = cartItem ? cartItem.querySelector('textarea[id^="message-"]') : null;
    const currentNotes = notesTextarea ? notesTextarea.value : '';
    
    console.log('Handling substitution toggle:', { 
      lineItemKey, 
      isAllowed, 
      currentQuantity,
      currentNotes,
      quantityInput: quantityInput ? quantityInput.value : 'not found'
    });

    const body = JSON.stringify({
      id: lineItemKey,
      quantity: currentQuantity,
      note: this.getCartNote(),
      properties: {
        Substitutions: isAllowed ? "allowed" : "not_allowed",
        Message: currentNotes
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    console.log('Sending cart change request:', body);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        if (parsedState.errors) {
          this.updateLiveRegions(lineItemKey, parsedState.errors);
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      });
  }

  handleNotesChange(textarea) {
    // Find the toggle in the same cart item to get the line item key
    const cartItem = textarea.closest('.cart-item');
    const toggle = cartItem ? cartItem.querySelector('.switch-container input[type="checkbox"]') : null;
    const lineItemKey = toggle ? toggle.dataset.lineItemKey : null;
    const message = textarea.value;
    const isAllowed = toggle ? toggle.checked : false;
    
    // Get the current quantity from the quantity input
    const quantityInput = cartItem ? cartItem.querySelector('.quantity__input') : null;
    const currentQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
    
    // Get the save button and show loading state
    const saveButton = textarea.closest('.note-field').querySelector('.save-note-button');
    if (saveButton) {
      saveButton.disabled = true;
      saveButton.classList.add('loading');
    }
    
    console.log('Handling notes change:', { 
      lineItemKey, 
      message,
      isAllowed,
      currentQuantity,
      toggle: toggle ? toggle.dataset : 'not found',
      cartItem: cartItem ? 'found' : 'not found'
    });

    if (!lineItemKey) {
      console.error('Could not find line item key for notes update');
      if (saveButton) {
        saveButton.disabled = false;
        saveButton.classList.remove('loading');
      }
      return;
    }

    const body = JSON.stringify({
      id: lineItemKey,
      quantity: currentQuantity,
      note: this.getCartNote(),
      properties: {
        Substitutions: isAllowed ? "allowed" : "not_allowed",
        Message: message
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    console.log('Sending cart change request for notes:', body);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        if (parsedState.errors) {
          this.updateLiveRegions(lineItemKey, parsedState.errors);
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
      })
      .catch((error) => {
        console.error('Error updating cart notes:', error);
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        if (saveButton) {
          saveButton.disabled = false;
          saveButton.classList.remove('loading');
        }
      });
  }
}

customElements.define('cart-items', CartItems);



document.addEventListener("DOMContentLoaded", function() {
  const postcodeInput = document.querySelector(".bcdp-widget-input");
  if (postcodeInput && customerPostalCode) {
    postcodeInput.value = customerPostalCode;
  }

  // Add event listeners for cart note changes
  const cartNote = document.getElementById('Cart-note');
  const cartDrawerNote = document.getElementById('CartDrawer-Note');
  
  console.log('DOMContentLoaded: Looking for cart note elements');
  console.log('Cart note element found:', !!cartNote);
  console.log('Cart drawer note element found:', !!cartDrawerNote);
  
  if (cartNote) {
    console.log('Setting up event listeners for main cart note');
    cartNote.addEventListener('change', function() {
      console.log('Main cart note change event triggered');
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.handleCartNoteChange(this);
      }
    });
    
    cartNote.addEventListener('blur', function() {
      console.log('Main cart note blur event triggered');
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.handleCartNoteChange(this);
      }
    });
  }
  
  if (cartDrawerNote) {
    console.log('Setting up event listeners for cart drawer note');
    cartDrawerNote.addEventListener('change', function() {
      console.log('Cart drawer note change event triggered');
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.handleCartNoteChange(this);
      }
    });
    
    cartDrawerNote.addEventListener('blur', function() {
      console.log('Cart drawer note blur event triggered');
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.handleCartNoteChange(this);
      }
    });
  }
});